import React from "react";
import "./Note.css";        // ← reuse exact same styles
import "./Note.dark.css";   // ← reuse dark styles

function PreviewNote({ post, dark = false }) {

  const statusLabel =
    post.status === "released"
      ? "Released"
      : post.status === "active"
      ? "Active"
      : "Standby";

  return (
    <div className={`note-item ${post.status} ${dark ? "note-item-dark" : ""} ${post.isPriority ? "priority" : ""}`}>

      {/* META ROW */}
      <div className="note-item-meta">
        <span className={`note-item-status ${post.status}`}>
          <span className="note-item-dot" />
          {statusLabel}
        </span>

        {post.updates?.length > 0 && (
          <span className="note-item-updates">
            {post.updates.length} {post.updates.length === 1 ? "update" : "updates"}
          </span>
        )}

        {post.category && (
          <span className="note-item-updates" style={{ color: "#9ca3af", background: "rgba(156,163,175,0.1)" }}>
            {post.category}
          </span>
        )}
      </div>

      {/* TEXT — span instead of Link, no routing in preview */}
      <span className="note-item-text">
        {post.note?.length > 220
          ? post.note.substring(0, 220) + "…"
          : post.note}
      </span>

      {/* ACTIONS ROW */}
      <div className="note-item-actions">
        {post.isPriority && (
          <span className="icon-btn priority-star active" aria-label="Priority">
            ★
          </span>
        )}

        <div className="note-item-actions-right">
          {post.status === "released" ? (
            <button className="note-item-btn released" disabled>Released</button>
          ) : (
            <button className="note-item-btn outline" disabled>Release</button>
          )}
        </div>
      </div>

    </div>
  );
}

export default PreviewNote;
